import { mergeEditingObject } from "../../../utils/codeSplit";
import editingActions, { actionTypes as editingActionTypes } from "./actions.editing";
import readonlyActions, { actionTypes as readonlyActionTypes } from "./actions.readonly";

export const actionTypes = mergeEditingObject(readonlyActionTypes, editingActionTypes);

export default mergeEditingObject(readonlyActions, editingActions);
